module.exports = __webpack_public_path__ + "static/img/3areaB_7.c81b3a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_7.png
// module id = 1179
// module chunks = 1